import { registerLocale, getNames } from 'i18n-iso-countries'

registerLocale(require("i18n-iso-countries/langs/en.json"))
const countryObj = getNames("en", { select: "official" });
const countryArr = Object.entries(countryObj).map(([key, value]) => {
    return {
        code: key,
        name: value
    }
});

export function getCountries() {
    return countryArr;
}

export function getCountryName(countryCode) {
    return countryArr.find(c => c.code === countryCode).name;
}

const COUNTRY_ADDRESS_POSTALS = [{
    abbrev: 'AF',
    name: 'Afghanistan',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'AL',
    name: 'Albania',
    postal: /(120|122)[0-9]{2}/,
}, {
    abbrev: 'DZ',
    name: 'Algeria',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'AS',
    name: 'American Samoa',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'AD',
    name: 'Andorra',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'AO',
    name: 'Angola',
}, {
    abbrev: 'AI',
    name: 'Anguilla',
    postal: /AI-2640/,
}, {
    abbrev: 'AG',
    name: 'Antigua and Barbuda',
}, {
    abbrev: 'AR',
    name: 'Argentina',
    postal: /[A-Z]{1}[0-9]{4}[A-Z]{3}/,
}, {
    abbrev: 'AM',
    name: 'Armenia',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'AW',
    name: 'Aruba',
}, {
    abbrev: 'AU',
    name: 'Australia',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'AT',
    name: 'Austria',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'AZ',
    name: 'Azerbaijan',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'BS',
    name: 'Bahamas',
}, {
    abbrev: 'BH',
    name: 'Bahrain',
}, {
    abbrev: 'BD',
    name: 'Bangladesh',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'BB',
    name: 'Barbados',
    postal: /BB[0-9]{5}/,
}, {
    abbrev: 'BY',
    name: 'Belarus',
    postal: /[0-9]{6}/,
}, {
    abbrev: 'BE',
    name: 'Belgium',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'BZ',
    name: 'Belize',
}, {
    abbrev: 'BJ',
    name: 'Benin',
}, {
    abbrev: 'BM',
    name: 'Bermuda',
    postal: /[A-Z]{2}[0-9]{2}/,
}, {
    abbrev: 'BT',
    name: 'Bhutan',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'BO',
    name: 'Bolivia',
}, {
    abbrev: 'BQ',
    name: 'Bonaire',
}, {
    abbrev: 'BA',
    name: 'Bosnia and Herzegovina',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'BW',
    name: 'Botswana',
}, {
    abbrev: 'BR',
    name: 'Brazil',
    postal: /[0-9]{5}-[0-9]{3}/,
}, {
    abbrev: 'BN',
    name: 'Brunei',
    postal: /[A-Z]{2}[0-9]{4}/,
}, {
    abbrev: 'BG',
    name: 'Bulgaria',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'BF',
    name: 'Burkina Faso',
}, {
    abbrev: 'BI',
    name: 'Burundi',
}, {
    abbrev: 'KH',
    name: 'Cambodia',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'CM',
    name: 'Cameroon',
}, {
    abbrev: 'CA',
    name: 'Canada',
    postal: /[A-Z][0-9][A-Z] ?[0-9][A-Z][0-9]/,
}, {
    abbrev: 'CI',
    name: 'Canary Islands',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'CV',
    name: 'Cape Verde',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'KY',
    name: 'Cayman Islands',
    postal: /[A-Z]{2}[0-9]-[0-9]{4}/,
}, {
    abbrev: 'CF',
    name: 'Central African Republic',
}, {
    abbrev: 'TD',
    name: 'Chad',
}, {
    abbrev: 'CI',
    name: 'Channel Islands',
    postal: /[A-Z]{2}[0-9]{2}/,
}, {
    abbrev: 'CL',
    name: 'Chile',
    postal: /[0-9]{7}/,
}, {
    abbrev: 'CN',
    name: "China, People's Republic",
    postal: /[0-9]{5}/,
}, {
    abbrev: 'CO',
    name: 'Colombia',
    postal: /[0-9]{6}/,
}, {
    abbrev: 'KM',
    name: 'Comoros',
}, {
    abbrev: 'CG',
    name: 'Congo',
}, {
    abbrev: 'CD',
    name: 'Congo, The Democratic Republic of',
}, {
    abbrev: 'CK',
    name: 'Cook Islands',
}, {
    abbrev: 'CR',
    name: 'Costa Rica',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'CI',
    name: "Côte d'Ivoire",
}, {
    abbrev: 'HR',
    name: 'Croatia',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'CU',
    name: 'Cuba',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'CW',
    name: 'Curacao',
}, {
    abbrev: 'CY',
    name: 'Cyprus',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'CZ',
    name: 'Czech Republic',
    postal: /[0-9]{3} [0-9]{2}/,
}, {
    abbrev: 'DK',
    name: 'Denmark',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'DJ',
    name: 'Djibouti',
}, {
    abbrev: 'DM',
    name: 'Dominica',
}, {
    abbrev: 'DO',
    name: 'Dominican Republic',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'TL',
    name: 'East Timor',
}, {
    abbrev: 'EC',
    name: 'Ecuador',
    postal: /[0-9]{6}/,
}, {
    abbrev: 'EG',
    name: 'Egypt',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'SV',
    name: 'El Salvador',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'ER',
    name: 'Eritrea',
}, {
    abbrev: 'EE',
    name: 'Estonia',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'ET',
    name: 'Ethiopia',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'FK',
    name: 'Falkland Islands',
    postal: /FIQQ 1ZZ/,
}, {
    abbrev: 'FO',
    name: 'Faroe Islands',
    postal: /[0-9]{3}/,
}, {
    abbrev: 'FJ',
    name: 'Fiji',
}, {
    abbrev: 'FI',
    name: 'Finland',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'FR',
    name: 'France',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'PF',
    name: 'French Polynesia',
    postal: /987[0-9]{2}/,
    range: ['98700', '98790'],
}, {
    abbrev: 'GA',
    name: 'Gabon',
}, {
    abbrev: 'GM',
    name: 'Gambia',
}, {
    abbrev: 'GE',
    name: 'Georgia',
}, {
    abbrev: 'DE',
    name: 'Germany',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'GH',
    name: 'Ghana',
}, {
    abbrev: 'GI',
    name: 'Gibraltar',
    postal: /GX11 1AA/,
}, {
    abbrev: 'GR',
    name: 'Greece',
    postal: /[0-9]{3} [0-9]{2}/,
}, {
    abbrev: 'GL',
    name: 'Greenland',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'GD',
    name: 'Grenada',
}, {
    abbrev: 'GP',
    name: 'Guadeloupe',
    postal: /971[0-9]{2}/,
    range: ['97100', '97190'],
}, {
    abbrev: 'GU',
    name: 'Guam',
    // US postal code
    // https://stackoverflow.com/questions/2577236/regex-for-zip-code
    postal: /^\d{5}(?:[-\s]\d{4})?$/,
    range: ['96910', '96932'],
}, {
    abbrev: 'GT',
    name: 'Guatemala',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'GG',
    name: 'Guernsey',
    // UK postal code
    // https://stackoverflow.com/questions/164979/regex-for-matching-uk-postcodes
    postal: /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/,
}, {
    abbrev: 'GW',
    name: 'Guinea-Bissau',
    postal: /[0-9]{4}/,

}, {
    abbrev: 'GQ',
    name: 'Guinea-Equatorial',
}, {
    abbrev: 'GN',
    name: 'Guinea Republic',
    postal: /[0-9]{3}/,
}, {
    abbrev: 'GY',
    name: 'Guyana (British)',
}, {
    abbrev: 'GF',
    name: 'Guyana (French)',
    postal: /973[0-9]{2}/,
    range: ['97300', '97390'],
}, {
    abbrev: 'HT',
    name: 'Haiti',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'HN',
    name: 'Honduras',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'HK',
    name: 'Hong Kong',
}, {
    abbrev: 'HU',
    name: 'Hungary',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'IS',
    name: 'Iceland',
    postal: /[0-9]{3}/,
}, {
    abbrev: 'IN',
    name: 'India',
    // https://stackoverflow.com/questions/33865525/indian-pincode-validation-regex-only-six-digits-shouldnt-start-with-0
    postal: /^[1-9][0-9]{5}$/,
}, {
    abbrev: 'ID',
    name: 'Indonesia',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'IR',
    name: 'Iran',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'IQ',
    name: 'Iraq',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'IE',
    name: 'Ireland, Republic of',
    // https://stackoverflow.com/questions/33391412/validation-for-irish-eircode
    postal: /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/,
}, {
    abbrev: 'FK',
    name: 'Islas Malvinas',
    postal: /FIQQ 1ZZ/,
}, {
    abbrev: 'IL',
    name: 'Israel',
    postal: /[0-9]{5}|[0-9]{7}/,
}, {
    abbrev: 'IT',
    name: 'Italy',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'CI',
    name: 'Ivory Coast',
}, {
    abbrev: 'JM',
    name: 'Jamaica',
}, {
    abbrev: 'JP',
    name: 'Japan',
    postal: /[0-9]{3}-[0-9]{4}/,
}, {
    abbrev: 'JE',
    name: 'Jersey',
    postal: /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/,
}, {
    abbrev: 'JO',
    name: 'Jordan',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'KZ',
    name: 'Kazakhstan',
    postal: /[0-9]{6}/,
}, {
    abbrev: 'KE',
    name: 'Kenya',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'KI',
    name: 'Kiribati',
}, {
    abbrev: 'KR',
    name: 'Korea, Republic of',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'KP',
    name: 'Korea, The D.P.R of',
}, {
    abbrev: 'XK',
    name: 'Kosovo',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'KW',
    name: 'Kuwait',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'KG',
    name: 'Kyrgyzstan',
    postal: /[0-9]{6}/,
}, {
    abbrev: 'LA',
    name: 'Laos',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'LV',
    name: 'Latvia',
    postal: /LV-[0-9]{4}/,
}, {
    abbrev: 'LB',
    name: 'Lebanon',
    postal: /[0-9]{4} [0-9]{4}/,
}, {
    abbrev: 'LS',
    name: 'Lesotho',
    postal: /[0-9]{3}/,
}, {
    abbrev: 'LR',
    name: 'Liberia',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'LY',
    name: 'Libya',
}, {
    abbrev: 'LI',
    name: 'Liechtenstein',
    postal: /[0-9]{4}/,
    range: ['9485', '9498'],
}, {
    abbrev: 'LT',
    name: 'Lithuania',
    postal: /LT-[0-9]{5}/,
}, {
    abbrev: 'LU',
    name: 'Luxembourg',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'MO',
    name: 'Macau',
}, {
    abbrev: 'MK',
    name: 'Macedonia, Republic of',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'MG',
    name: 'Madagascar',
    postal: /[0-9]{3}/,
}, {
    abbrev: 'MW',
    name: 'Malawi',
}, {
    abbrev: 'MY',
    name: 'Malaysia',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'MV',
    name: 'Maldives',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'ML',
    name: 'Mali',
}, {
    abbrev: 'MT',
    name: 'Malta',
    postal: /[A-Z]{3} [0-9]{4}/,
}, {
    abbrev: 'MH',
    name: 'Marshall Islands',
    postal: /^\d{5}(?:[-\s]\d{4})?$/,
    range: ['96960', '96970'],
}, {
    abbrev: 'MQ',
    name: 'Martinique',
    postal: /972[0-9]{2}/,
    range: ['97200', '97290'],
}, {
    abbrev: 'MR',
    name: 'Mauritania',
}, {
    abbrev: 'MU',
    name: 'Mauritius',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'YT',
    name: 'Mayotte',
    postal: /976[0-9]{2}/,
    range: ['97600', '97690'],
}, {
    abbrev: 'MX',
    name: 'Mexico',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'MD',
    name: 'Moldova, Republic of',
    postal: /MD-?[0-9]{4}/,
}, {
    abbrev: 'MC',
    name: 'Monaco',
    postal: /980[0-9]{2}/,
}, {
    abbrev: 'MN',
    name: 'Mongolia',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'ME',
    name: 'Montenegro',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'MS',
    name: 'Montserrat',
    postal: /MSR [0-9]{4}/,
    range: ['MSR 1110', 'MSR 1350'],
}, {
    abbrev: 'MA',
    name: 'Morocco',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'MZ',
    name: 'Mozambique',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'MM',
    name: 'Myanmar',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'NA',
    name: 'Namibia',
}, {
    abbrev: 'NR',
    name: 'Nauru',
}, {
    abbrev: 'NP',
    name: 'Nepal',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'NL',
    name: 'Netherlands',
    // https://rgxdb.com/r/4W9GV8AC
    postal: /^(?:NL-)?(\d{4})\s*([A-Z]{2})$/i,
}, {
    abbrev: 'NC',
    name: 'New Caledonia',
    postal: /988[0-9]{2}/,
    range: ['96950', '96952'],
}, {
    abbrev: 'NZ',
    name: 'New Zealand',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'NI',
    name: 'Nicaragua',
}, {
    abbrev: 'NE',
    name: 'Niger',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'NG',
    name: 'Nigeria',
    postal: /[0-9]{6}/,
}, {
    abbrev: 'NU',
    name: 'Niue',
}, {
    abbrev: 'MP',
    name: 'Northern Mariana Islands',
    postal: /^\d{5}(?:[-\s]\d{4})?$/,
}, {
    abbrev: 'NO',
    name: 'Norway',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'OM',
    name: 'Oman',
    postal: /[0-9]{3}/,
}, {
    abbrev: 'PK',
    name: 'Pakistan',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'PW',
    name: 'Palau',
    postal: /^\d{5}(?:[-\s]\d{4})?$/,
}, {
    abbrev: 'PA',
    name: 'Panama',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'PG',
    name: 'Papua New Guinea',
    postal: /[0-9]{3}/,
}, {
    abbrev: 'PY',
    name: 'Paraguay',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'PE',
    name: 'Peru',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'PH',
    name: 'Philippines',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'PL',
    name: 'Poland',
    postal: /[0-9]{2}-[0-9]{3}/,
}, {
    abbrev: 'PT',
    name: 'Portugal',
    postal: /[0-9]{4}-[0-9]{3}/,
}, {
    abbrev: 'PR',
    name: 'Puerto Rico',
    postal: /^\d{5}(?:[-\s]\d{4})?$/,
}, {
    abbrev: 'QA',
    name: 'Qatar',
}, {
    abbrev: 'RE',
    name: 'Réunion',
    postal: /974[0-9]{2}/,
    range: ['97400', '97490'],
}, {
    abbrev: 'RO',
    name: 'Romania',
    postal: /[0-9]{6}/,
}, {
    abbrev: 'RU',
    name: 'Russian Federation',
    postal: /[0-9]{6}/,
}, {
    abbrev: 'RW',
    name: 'Rwanda',
}, {
    abbrev: 'MP',
    name: 'Saipan',
    postal: /96950/,
}, {
    abbrev: 'WS',
    name: 'Samoa',
    postal: /WS[0-9]{4}/,
}, {
    abbrev: 'ST',
    name: 'Sao Tome and Principe',
}, {
    abbrev: 'SA',
    name: 'Saudi Arabia',
    postal: /[0-9]{5}(-[0-9]{4})?/,
}, {
    abbrev: 'SN',
    name: 'Senegal',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'RS',
    name: 'Serbia',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'SC',
    name: 'Seychelles',
}, {
    abbrev: 'SL',
    name: 'Sierra Leone',
}, {
    abbrev: 'SG',
    name: 'Singapore',
    postal: /[0-9]{6}/,
}, {
    abbrev: 'SK',
    name: 'Slovakia',
    postal: /[0-9]{3} [0-9]{2}/,
}, {
    abbrev: 'SI',
    name: 'Slovenia',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'SB',
    name: 'Solomon Islands',
}, {
    abbrev: 'SO',
    name: 'Somalia',
    postal: /[A-Z]{2} [0-9]{5}/,
}, {
    abbrev: 'ZA',
    name: 'South Africa',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'SS',
    name: 'South Sudan',
}, {
    abbrev: 'ES',
    name: 'Spain',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'LK',
    name: 'Sri Lanka',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'BL',
    name: 'St. Barthélemy',
    postal: /[0-9]{5}/,
    range: ['97100', '97190'],
}, {
    abbrev: 'VI',
    name: 'St. Croix',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'SE',
    name: 'St. Eustatius',
}, {
    abbrev: 'SH',
    name: 'St. Helena',
    postal: /STHL 1ZZ/,
}, {
    abbrev: 'AG',
    name: 'St. John',
    postal: /^\d{5}(?:[-\s]\d{4})?$/,
}, {
    abbrev: 'KN',
    name: 'St. Kitts and Nevis',
    postal: /[A-Z]{2}[0-9]{4}/,
}, {
    abbrev: 'LC',
    name: 'St. Lucia',
    postal: /[A-Z]{2}[0-9]{2} [0-9]{3}/,
}, {
    abbrev: 'SX',
    name: 'St. Maarten',
}, {
    abbrev: 'VI',
    name: 'St. Thomas',
}, {
    abbrev: 'VC',
    name: 'St. Vincent and the Grenadines',
    postal: /VC[0-9]{4}/,
}, {
    abbrev: 'SD',
    name: 'Sudan',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'SR',
    name: 'Suriname',
}, {
    abbrev: 'SZ',
    name: 'Swaziland',
    postal: /[A-Z]{1}[0-9]{3}/,
}, {
    abbrev: 'SE',
    name: 'Sweden',
    postal: /[0-9]{3} [0-9]{2}/,
}, {
    abbrev: 'CH',
    name: 'Switzerland',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'SY',
    name: 'Syria',
}, {
    abbrev: 'PF',
    name: 'Tahiti',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'TW',
    name: 'Taiwan',
    postal: /[0-9]{3}(-[0-9]{2})?/,
}, {
    abbrev: 'TZ',
    name: 'Tanzania',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'TH',
    name: 'Thailand',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'TG',
    name: 'Togo',
}, {
    abbrev: 'TO',
    name: 'Tonga',
}, {
    abbrev: 'VG',
    name: 'Tortola',
    postal: /VG[0-9]{4}/,
}, {
    abbrev: 'TT',
    name: 'Trinidad and Tobago',
    postal: /[0-9]{6}/,
}, {
    abbrev: 'TN',
    name: 'Tunisia',
    postal: /[0-9]{4}/,
}, {
    abbrev: 'TR',
    name: 'Turkey',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'TM',
    name: 'Turkmenistan',
    postal: /[0-9]{6}/,
}, {
    abbrev: 'TC',
    name: 'Turks and Caicos Islands',
    postal: /TKCA 1ZZ/,
}, {
    abbrev: 'TV',
    name: 'Tuvalu',
}, {
    abbrev: 'UG',
    name: 'Uganda',
}, {
    abbrev: 'UA',
    name: 'Ukraine',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'AE',
    name: 'United Arab Emirates',
}, {
    abbrev: 'GB',
    name: 'United Kingdom',
    postal: /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})/,
}, {
    abbrev: 'US',
    name: 'United States of America',
    postal: /^\d{5}(?:[-\s]\d{4})?$/,
}, {
    abbrev: 'UY',
    name: 'Uruguay',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'UZ',
    name: 'Uzbekistan',
    postal: /[0-9]{6}/,
}, {
    abbrev: 'VU',
    name: 'Vanuatu',
}, {
    abbrev: 'VE',
    name: 'Venezuela',
    postal: /[0-9]{4}(-[A-Z]{1})?/,
}, {
    abbrev: 'VN',
    name: 'Vietnam',
    postal: /[0-9]{6}/,
}, {
    abbrev: 'VG',
    name: 'Virgin Islands (British)',
    postal: /VG[0-9]{4}/,
}, {
    abbrev: 'VI',
    name: 'Virgin Islands (US)',
    range: ['00801', '00851'],
    postal: /^\d{5}(?:[-\s]\d{4})?$/,
}, {
    abbrev: 'YE',
    name: 'Yemen',
}, {
    abbrev: 'ZM',
    name: 'Zambia',
    postal: /[0-9]{5}/,
}, {
    abbrev: 'ZW',
    name: 'Zimbabwe',
}]

export function validateZip(country, zip) {
    const rgex = COUNTRY_ADDRESS_POSTALS.find(c => c.abbrev === country).postal;
    if(!rgex) return "no regex";
    else return rgex.test(zip);
}

